<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/">Inicio</a></li>
                <li>Listado de Noticias</li>
            </ul>
            <h2>Listado de Noticias
            </h2>
        </div>
    </div>
</div>

<app-loading *ngIf="!flagLoaded" class="m-5"></app-loading><br>

<div class="profile-area pb-70 contenido-tabla">
    <div class="container">

        <div class="profile-courses-quizzes">
            <h3>Listado de Noticias
            </h3> <a routerLink="/alta-noticia"><i class="fas fa-plus"></i> Agregar Noticia</a>

            <mat-form-field class="filtrarInput">
                <mat-label>Filtrar</mat-label>
                <input matInput (keyup)="applyFilter($event)" placeholder="" autocomplete="off">
            </mat-form-field>

            <div class="mat-elevation-z8">
                <table mat-table [dataSource]="dataSource" matSort>

                    <!-- Column -->
                    <ng-container matColumnDef="nombre">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Titulo </th>
                        <td mat-cell *matCellDef="let element"> {{element.nombre}} </td>
                    </ng-container>

                    <!-- Column -->
                    <ng-container matColumnDef="vigente">

                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Estado </th>
                        <td mat-cell *matCellDef="let element">
                            <div *ngIf="element.vigente == true"><span class="badge bg-success">Vigente</span></div>
                            <div *ngIf="element.vigente == false"><span class="badge bg-danger">No vigente</span></div>
                        </td>

                    </ng-container>

                    <!-- Column -->
                    <ng-container matColumnDef="_id">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Acciones </th>
                        <td mat-cell *matCellDef="let element">
                            <button (click)="verActividad(element._id)" type="button" class="btn btn-warning"><i class="fas fa-edit"></i></button>
                            <button (click)="eliminarNoticia(element._id)" type="button" class="btn btn-danger"><i class="fas fa-trash"></i></button>
                        </td>
                    </ng-container>
                    

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="example-element-row"></tr>
                </table>
                <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="10"></mat-paginator>

            </div>
        </div>
    </div>
</div>
